import {ValueObject} from '@s-ui/domain'

export class ModelDetailContentValueObject extends ValueObject {
  /**
   * @param {String} deps.title
   * @param {String} deps.description
   * @param {Array<String>} deps.photos
   * @param {Array<String>} deps.pros
   * @param {Array<String>} deps.cons
   * @param {StructuredDataValueObject} deps.seoFaq
   * @param {FaqsListValueObject>} deps.faq
   * */
}
